/* eslint-disable no-magic-numbers */
const usaBackPublicado = window.location.hostname.includes('market')
const protocol = usaBackPublicado ? 'https://' : 'http://'

const preEndpointEBM = usaBackPublicado
  ? import.meta.env.VITE_API_ENDPOINT_EBM
  : `:${import.meta.env.VITE_API_PORT}/api`

const loginPort = import.meta.env.VITE_API_PORT
  ? import.meta.env.VITE_API_PORT[1] === '0'
    ? import.meta.env.VITE_API_PORT.slice(2)
    : import.meta.env.VITE_API_PORT.slice(1)
  : null

const ebuyLoginHostname = window.location.hostname.includes('market')
  ? `www.${window.location.hostname.slice(7)}`
  : loginPort && `${window.location.hostname}:${loginPort}`

const hostFinal = import.meta.env.VITE_API_TEST || window.location.hostname

export const API_ENDPOINT_EBM = protocol + hostFinal + preEndpointEBM
export const API_ENDPOINT_EBM_PASARELA = `https://${hostFinal}${import.meta.env.VITE_API_PASARELA_EBM}`

export const logoutURL = protocol + ebuyLoginHostname
